module.exports = __webpack_public_path__ + "img/grz-2.3fb20f18.png";